import { Input } from "@progress/kendo-react-inputs";
import PropTypes from "prop-types";
import React from "react";

export const LabelInfo = (fieldRenderProps) => {
  const { label, value, col, values = [] } = fieldRenderProps;

  return (
    <div className={`col-md-${col ? col : 1} customCol`}>
      <span>{label} :</span>
      <div className="customCol">
        <Input
          id={label}
          readOnly={true}
          value={value}
          className="customInput"
        />
        {values.map((e, i) => (
          <Input
            key={i}
            id={label}
            readOnly={true}
            value={e}
            className="customInput"
          />
        ))}
      </div>
    </div>
  );
};

LabelInfo.propTypes = {
  col: PropTypes.number,
  label: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  value: PropTypes.string,
  values: PropTypes.array,
};
